<template>
  <NavBar
    :active="activeMenyIndex"
    :create_router_to="{name: 'catalog' , params: {org: $route.params.org}}"
    :create_text="$t('Purchasing.CreatePurch')"
    :filter="filterOpt"
    :items="applications"
    :loading.sync="loading"
    :mode.sync="mode"
    :types="types"
    unload
    @changeFilter="$emit('changeFilter')"
    @filterItems="filterByTypes">
    <template #list_item="{ item }">
      <div class="type-name pr-1">
        {{ $t(item.name) }}
      </div>
      <div class="type-count">
        {{ app_count[item.type] ? app_count[item.type].count : '-' }}
      </div>
    </template>

    <template #additional_filters>
      <PinnedFiltersTemplates
        ref="filters_templates"
        :small="mini">
        <template #filter_template="{ template }">
          <PurchFilters :item="template"/>
        </template>
      </PinnedFiltersTemplates>
    </template>
  </NavBar>
</template>

<script>
import NavBar from 'components/common/blocks/NavBar.vue'
import PurchFilters from 'components/purchasing/PurchFilters.vue'
import PinnedFiltersTemplates from 'components/common/blocks/PinnedFiltersTemplates.vue'

import { filterSortMixin, snackbarMixin, storageMixin } from 'mixins'

import { mapGetters } from 'vuex'

export default {
  name: 'purchNavBar',
  mixins: [
    filterSortMixin,
    snackbarMixin,
    storageMixin
  ],
  data() {
    return {
      activeMenyIndex: 0,
      filterOpt: {}
    }
  },
  props: {
    filter: Object,
    mini: Boolean,
    loading: Boolean,
    app_count: [Object, Array],
    applications: Array,
    types: Array
  },
  async mounted() {
    this.$_getPropFromDBStorage('purch_menuType', 0)
      .then((menuType) => {
        if (menuType !== this.activeMenyIndex) {
          this.filterByTypes(this.types[menuType])
        }
      })
  },
  computed: {
    ...mapGetters({
      user: 'GET_USER',
    }),
    mode: {
      get() {
        return this.mini
      },
      set(value) {
        this.$emit('update:mini', value)
      }
    },
  },
  methods: {
    filterByTypes(item) {
      const index = this.types.findIndex(i => i.type === item.type)
      if (index !== -1) {
        this.$_savePropToDBStorage('purch_menuType', index)
        this.activeMenyIndex = index
        this.$_closeSnackbar()
        this.$emit('changeFilter')

        this.$root.$emit('loadData', {bar: item.type })
      }
    },
    waiting(el ) {
      return el && el.acceptors  && this.user
        ? el.acceptors.find(it => it.status == 'Waiting' && it.user?.id?.trim() == this.user?.purchasingSettings?.userId?.trim() )
        : false
    }
  },
  components: {
    NavBar,
    PurchFilters,
    PinnedFiltersTemplates
  }
}
</script>
